import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api, formatApiError } from "../../lib/api";
import { useTitle } from "../../App";

export default function AdminLogin() {
  useTitle("Owner Login");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    if (loading) return;
    setLoading(true);
    setError("");
    try {
      await api.post("/auth/login", { email, password });
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="flex min-h-screen items-center justify-center bg-midnight px-6 text-mist">
      <div className="w-full max-w-md">
        <div className="mb-8 text-center">
          <span className="mx-auto flex h-12 w-12 items-center justify-center rounded-xl bg-gradient-to-br from-violet to-teal font-display text-2xl font-bold text-white">E</span>
          <h1 className="mt-5 font-display text-2xl font-bold">Ekavrix Owner Access</h1>
          <p className="mt-2 text-sm text-slate-400">Private area. Authorised users only.</p>
        </div>
        <form onSubmit={submit} className="card-dark space-y-4 p-8" data-testid="admin-login-form">
          <div>
            <label htmlFor="admin-email" className="mb-1.5 block text-xs font-medium text-slate-400">Email</label>
            <input id="admin-email" data-testid="admin-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="input-ek" placeholder="owner@ekavrix.com" />
          </div>
          <div>
            <label htmlFor="admin-password" className="mb-1.5 block text-xs font-medium text-slate-400">Password</label>
            <input id="admin-password" data-testid="admin-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="input-ek" placeholder="••••••••" />
          </div>
          {error && <p data-testid="admin-login-error" role="alert" className="rounded-lg border border-red-500/30 bg-red-500/[0.08] px-3 py-2 text-sm text-red-300">{error}</p>}
          <button data-testid="admin-login-submit" type="submit" disabled={loading} className="btn-primary w-full disabled:opacity-60">
            {loading ? <Loader2 size={16} className="animate-spin" /> : "Sign In"}
          </button>
        </form>
        <a href="/" className="mt-6 block text-center text-xs text-slate-500 transition-colors hover:text-slate-300">Back to ekavrix.com</a>
      </div>
    </div>
  );
}
